import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { capturePHEvents } from '../analytics/posthog.analytics';
import { fetchCitiesForIndia, fetchStatesForIndia, getUserDetails } from '../service/user.service';
import { getCke, delAllCke } from '../helper/cookieHelper';
import { ADD_GEO_DATA, REMOVE_ORG, UPDATE_ORG, USER_LOADING, USER_LOGIN } from '../redux/constants';
import { FilterArrayByKey } from '../helper/commonHelper';
import FainlearnLoadingSvg from '../svg/FainlearnLoadingSvg';
import { PH_LOGGED_IN } from '../utils/posthog.eventNames';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fethcUser() {
      if (!location.pathname.includes('/enroll')) {
        if (getCke('userId') && getCke('accessToken')) {
          const stateAndCityRes = await Promise.all([fetchStatesForIndia(), fetchCitiesForIndia()]);
          const res = await getUserDetails(getCke('userId'));
          if (res) {
            const obj = {
              currentUser: res.user,
              isLogin: true,
              loading: false
            };
            // State is available
            if (stateAndCityRes.length > 0) {
              dispatch({
                type: ADD_GEO_DATA,
                payload: {
                  cities: FilterArrayByKey(stateAndCityRes[1], 'name'),
                  states: FilterArrayByKey(stateAndCityRes[0], 'name')
                }
              });
            }
            capturePHEvents(PH_LOGGED_IN, { userData: res.user });
            dispatch({ type: USER_LOGIN, response: obj });
            dispatch({ type: UPDATE_ORG, payload: res.orgList });
            setLoading(false);
            if (res.user?.isOnboarding) {
              navigate('/pick-user', { replace: true });
            }
            if (!res.user?.isOnboarding && location.pathname.includes('/login')) {
              navigate('/dashboard/app', { replace: true });
            }
            if (!res.user?.isOnboarding && location.pathname.includes('/pick-user')) {
              navigate('/dashboard/app', { replace: true });
            }
          } else {
            const obj = {
              currentUser: null,
              isLogin: false,
              loading: false
            };
            dispatch({ type: USER_LOGIN, response: obj });
            dispatch({ type: REMOVE_ORG });
            setLoading(false);
            navigate('/login', { replace: true });
            delAllCke();
          }
        } else {
          const obj = {
            currentUser: null,
            isLogin: false,
            loading: false
          };
          dispatch({ type: USER_LOGIN, response: obj });
          dispatch({ type: REMOVE_ORG });
          setLoading(false);
          navigate('/login', { replace: true });
          // navigate('/pick-user', { replace: true });
          delAllCke();
        }
      } else {
        setLoading(false);
        dispatch({ type: USER_LOADING, payload: false });
      }
    }
    fethcUser();
  }, []);

  const value = useMemo(() => ({}), []);
  return (
    <AuthContext.Provider value={value}>
      {loading ? (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          height="100vh"
        >
          <FainlearnLoadingSvg />
        </Stack>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
